// Given a string of HTML (not JSX), copy it to the clipboard so that it
// can be pasted into a rich text editor and preserve text formatting.
// Rich text copy works for Chrome and Safari, but `plaintext` is
// required as a fallback for Firefox which doesn't support ClipboardItem
export async function copyRichText(html: string, plaintext: string) {
  const typeRich = "text/html";
  const blobRich = new Blob([html], { type: typeRich });

  const typePlain = "text/plain";
  const blobPlain = new Blob([html], { type: typePlain });

  try {
    if (typeof ClipboardItem !== "undefined") {
      // Modern browsers with ClipboardItem support
      const data = [
        new ClipboardItem({ [typeRich]: blobRich, [typePlain]: blobPlain }),
      ];
      await navigator.clipboard.write(data);
    } else {
      // Fallback for Firefox and other browsers without ClipboardItem support
      // This will only copy plain text
      await navigator.clipboard.writeText(plaintext);
    }
  } catch (error) {
    console.error("Error copying text: ", error);
  }
}

export function getIsInFountainIntegration() {
  const queryParams = new URLSearchParams(window.location.search);
  return queryParams.get("int") === "fountain";
}

/**
 * The browser's IANA time zone name (e.g. "America/New_York"). Used to tell
 * performance endpoints which zone their day buckets should align to. Read at
 * request time in the endpoint layer so callers don't have to thread it
 * through query args (and so it stays out of RTK Query cache keys).
 */
export function getBrowserTimeZone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

/**
 * Split a comma-separated string into trimmed, non-empty values. Used by
 * inputs that accept CSV-style lists (e.g. funnel stage value mappings).
 */
export function splitTrimmedCsv(value: string): string[] {
  return value
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);
}
